import { createContext } from 'react';

import { captureException } from '@sentry/react';

import type { UserPreferencesService, UserService } from '@cognite/apm-client';
import { makeToast } from '@cognite/cogs-lab-v11';
import { useAuthContext } from '@cognite/e2e-auth';

import { useUserServices } from '../cdm-use-user-services';

export interface UseRegisterCurrentUserContextInterface {
  useAuthContext: () => {
    authState: {
      user: {
        cdfId: string;
      };
    };
  };
  makeToast: typeof makeToast;
  captureException: typeof captureException;
  useUserServices: () => {
    userService: Pick<UserService, 'getCurrentUser' | 'upsert'>;
    userPreferencesService: Pick<UserPreferencesService, 'upsert'>;
  };
}

const defaultValue: UseRegisterCurrentUserContextInterface = {
  useAuthContext,
  makeToast,
  captureException,
  useUserServices,
};

export const UseRegisterCurrentUserContext =
  createContext<UseRegisterCurrentUserContextInterface>(defaultValue);
